import React, { Fragment, useState } from 'react'
import cx from 'classnames'

import MaximizedWidgetPreview from './MaximizedWidgetPreview'
import MinimizedWidgetPreview from './MinimizedWidgetPreview'
import styles from './WidgetPreview.module.css'

const WidgetPreview = (props) => {
  const [isMaximizedPreview, togglePreview] = useState(true)

  const handlePreviewToggle = () => {
    togglePreview((state) => !state)
  }

  return (
    <Fragment>
      <div className={styles.TabContainer}>
        <div
          onClick={handlePreviewToggle}
          className={cx(styles.DefaultTab, { [styles.ActiveTab]: isMaximizedPreview })}
        >
          Maximized
        </div>
        <div
          onClick={handlePreviewToggle}
          className={cx(styles.DefaultTab, { [styles.ActiveTab]: !isMaximizedPreview })}
        >
          Minimized
        </div>
      </div>

      {isMaximizedPreview && <MaximizedWidgetPreview brandImageUrl={props.brandImage} />}
      {!isMaximizedPreview && <MinimizedWidgetPreview brandImageUrl={props.brandImage} />}
    </Fragment>
  )
}

export default WidgetPreview
